import { render, staticRenderFns } from "./VariazioniMassive.vue?vue&type=template&id=0f5f018e&scoped=true"
import script from "./VariazioniMassive.vue?vue&type=script&lang=ts"
export * from "./VariazioniMassive.vue?vue&type=script&lang=ts"
import style0 from "./VariazioniMassive.vue?vue&type=style&index=0&id=0f5f018e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f018e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5f018e')) {
      api.createRecord('0f5f018e', component.options)
    } else {
      api.reload('0f5f018e', component.options)
    }
    module.hot.accept("./VariazioniMassive.vue?vue&type=template&id=0f5f018e&scoped=true", function () {
      api.rerender('0f5f018e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consumi/VariazioniMassive.vue"
export default component.exports